import 'reflect-metadata';
import { Expose, plainToInstance, instanceToPlain } from 'class-transformer';

export class StoreSetting {
  @Expose({ name: 'default_store' })
  defaultStore: number;

  @Expose({ name: 'stock_status' })
  stockStatus: boolean;

  @Expose({ name: 'vendor_status' })
  vendorStatus: boolean;

  @Expose({ name: 'guest_checkout' })
  guestCheckout: boolean;

  @Expose({ name: 'store_name' })
  storeName: string;

  constructor(
    defaultStore: number,
    stockStatus: boolean,
    vendorStatus: boolean,
    guestCheckout: boolean,
    storeName: string
  ) {
    this.defaultStore = defaultStore;
    this.stockStatus = stockStatus;
    this.vendorStatus = vendorStatus;
    this.guestCheckout = guestCheckout;
    this.storeName = storeName;
  }

  static fromJson(json: Record<string, any>): StoreSetting {
    return plainToInstance(StoreSetting, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
